<script setup lang="ts">
</script>

<template>
<span class="xicon baseline">
    <svg width="32" height="32" viewBox="0 0 8.4666661 8.466667">
<g
    transform="translate(-68.579204,-80.103198)"
    id="layer1">
    <g
        style="stroke-width:0.9447552"
        transform="matrix(1.0584753,0,0,1.0584757,-4.2954619,-4.9893535)"
        id="g2004">
      <path
          d="m 74.990039,87.390656 a 0.68566263,0.68566263 0 0 0 0.68627,-0.686268 c 0,-0.864549 -0.7141,-1.454902 -1.538538,-1.73288 -0.824439,-0.277978 -1.756662,-0.277978 -2.581101,0 -0.824437,0.277978 -1.536513,0.868331 -1.536513,1.73288 a 0.68566263,0.68566263 0 0 0 0.684245,0.686268 h 2.143831 z"
          id="path1904" />
      <path
          d="m 74.289092,82.852822 a 1.4408611,1.4408611 0 0 1 -1.440861,1.440861 1.4408611,1.4408611 0 0 1 -1.440861,-1.440861 1.4408611,1.4408611 0 0 1 1.440861,-1.440861 1.4408611,1.4408611 0 0 1 1.440861,1.440861 z"
          id="path1918" />
    </g>
  </g>
    </svg>
</span>
</template>

<style scoped>
.xicon {
  display: inline-flex;
  align-self: center;
}

.xicon svg {
  height: 1em;
  width: 1em;
  fill: currentColor;
}

.xicon.baseline svg {
  top: .125em;
  position: relative;
}
</style>